import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/adaptive';
import { getViewport, generateImageUrl } from '../../../utils/webp';

import ProfileTile from './profile-tile';
import { Carousel } from '../../carousel';
import { FooterModal } from '../../footer-modal';
import { TitleImage } from '../../title-image';

import {
  Section, Wrapper, Contents,
} from '../styles/profiles.style';

const propTypes = {
  profiles: PropTypes.array,
};

const defaultProps = {
  profiles: [{}],
};

/**
 * Profile Component
 */
class Profiles extends React.Component {
  /**
   * Profile constructor
   * @param {object} props Incoming props
   */
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      localIsMobile: false,
      viewportWidth: 2400,
      modal: false,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Set mobile if SVP
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ localIsMobile: true });
    }
  }

  /**
   * Open modal
   * @param {string} title modal title
   * @param {object} content modal content
   * @param {object} e event object
   */
  openModal(title, content, e) {
    e.stopPropagation();
    this.setState({
      modal: {
        title,
        content,
      },
    });
  }

  /**
   * Close Modal
   */
  closeModal() {
    this.setState({
      modal: false,
    });
  }

  /**
   * Render the component
   * @returns {XML} React Component
   */
  render() {
    const { localIsMobile, viewportWidth, modal } = this.state;
    const {
      backgroundImage, profiles, title, titleImage,
    } = this.props;
    let contents;
    if (localIsMobile) {
      contents = (
        <Carousel numSlides={1} dots>
          {profiles.map((node, index) => (
            <ProfileTile key={index} openModal={this.openModal} {...node} />
          ))}
        </Carousel>
      );
    } else {
      contents = profiles.map((node, index) => <ProfileTile key={index} openModal={this.openModal} {...node} />);
    }
    const bkgd = backgroundImage && backgroundImage.file && backgroundImage.file.url;
    return (
      <Section backgroundImage={generateImageUrl(bkgd, viewportWidth)}>
        <Wrapper>
          <h2 className="section-title">
            <TitleImage
              src={titleImage && titleImage.file ? titleImage.file.url : ''}
              alt={title}
            />
          </h2>
          <Contents>{contents}</Contents>
        </Wrapper>
        { modal && (
          <FooterModal
            title={modal.title}
            content={modal.content}
            close={() => this.closeModal()}
          />
        ) }

      </Section>
    );
  }
}

Profiles.propTypes = propTypes;
Profiles.defaultProps = defaultProps;

export default Profiles;



// WEBPACK FOOTER //
// ./src/components/profiles/components/profiles.js